// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

export interface endLabRequestPayload {
  id: number;
  callback?: Function;
}
export interface endLabSuccessPayload {}

export interface endLabFailPayload {
  error: Error;
}

export const endLabActions = createAsyncAction(
  'elearning/END_LAB',
  'elearning/END_LAB_SUCCESS',
  'elearning/END_LAB_FAIL'
)<
  endLabRequestPayload,
  endLabSuccessPayload,
  endLabFailPayload
>();
